// src/pages/ValidationCompte.jsx
import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { Button, Typography, Card, Space } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const ValidationCompte = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [userId, setUserId] = useState(null);

  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const id = searchParams.get("id");
    if (id) {
      setUserId(id);
      localStorage.setItem("resetUserId", id); // stocke temporairement
    }
  }, [searchParams]);

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f0f2f5',
      padding: '1rem'
    }}>
      <Confetti width={windowDimensions.width} height={windowDimensions.height} numberOfPieces={200} />
      <Card style={{ textAlign: 'center', padding: '2rem', maxWidth: 600 }}>
        <Title level={2} style={{ color: '#52c41a' }}>🎉 Compte validé avec succès !</Title>
        <Paragraph>
          Votre compte a été validé avec succès.
          <br />
          <strong>Pour des raisons de sécurité, veuillez modifier votre mot de passe.</strong>
        </Paragraph>

        <Space direction="vertical" size="middle" style={{ width: "100%", marginTop: "1rem" }}>
          <Button
            type="primary"
            block
            onClick={() => navigate("/reset-password")}
          >
            Modifier mon mot de passe
          </Button>
          <Button
            type="default"
            block
            onClick={() => navigate("/login")}
          >
            Se connecter à votre espace membre
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default ValidationCompte;
